/* global global */

import * as cookie from "js-cookie";
import { FRONTEND_ROOT } from "../config/constants";

let [proto, domain] = FRONTEND_ROOT.split("://");
domain = domain.split(":")[0];

export const getLocalItem = key => {
  if (typeof global !== "undefined" && global.cookies) {
    return global.cookies[key];
  } else {
    return cookie.getJSON(key);
  }
};

export const setLocalItem = (key, value, params) => {
  return cookie.set(key, value, {
    domain,
    secure: proto === "https",
    ...params,
  });
};

export const removeLocalItem = (key, params) => {
  return cookie.remove(key, { domain, ...params });
};
